import { FunctionComponent, useContext } from 'react';
import { useUpdateUserName } from 'src/graphql/useUpdateUserName';
import EditUserNameModal, { FormModel } from './EditUserNameModal';
import { toast } from '@gmg/gmg-react-components';
import { getErrorMsgForToast } from '../toastErrorHandler';
import { useTranslation } from 'react-i18next';
import AppContext from 'src/AppContext';

export interface EditUserNameModalContainerProps {
    onClose?: () => void;
    onUserUpdate: () => void;
};

const EditUserNameModalContainer: FunctionComponent<EditUserNameModalContainerProps> = (props) => {
    const { t } = useTranslation();
    const user = useContext(AppContext).user!;
    const updateUserFullName = useUpdateUserName(user.userId, props.onUserUpdate);

    const handleSubmit = (formData: FormModel) => {
        const typedkeys = Object.keys(formData) as Array<keyof FormModel>;
        const hasPropBeenEdited = typedkeys.some(key => formData[key] !== user[key]);

        if (!hasPropBeenEdited) {
            props.onClose?.();
            return;
        }
        const { firstName, lastName } = formData;
        const pendingPromise = updateUserFullName.mutateAsync({ firstName, lastName });

        props.onClose?.();

        void toast.promise(pendingPromise, {
            loading: t('Common.Toast.Loading', 'Loading'),
            success: t('UpdateUserNameModalContainer.update_username_succes_toast_desc', 'User edited successfully.'),
            error: response => getErrorMsgForToast(response, t),
        });
    };

    return (
        <EditUserNameModal onClose={props.onClose} onFormSubmit={handleSubmit} />
    );
};

export default EditUserNameModalContainer;